import { render } from "./TemplateGroup.vue?vue&type=template&id=38a12b19&scoped=true"
import script from "./TemplateGroup.vue?vue&type=script&lang=js"
export * from "./TemplateGroup.vue?vue&type=script&lang=js"

import "./TemplateGroup.vue?vue&type=style&index=0&id=38a12b19&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38a12b19"]])

export default __exports__